const SITE_HEADER_SELECTOR = "[data-site-header]";
const HEADER_OFFSET_CSS_VAR = "--site-header-offset";
const DEFAULT_HEADER_OFFSET_PX = 88;

export function getSiteHeaderOffsetPx(): number {
  const header = document.querySelector<HTMLElement>(SITE_HEADER_SELECTOR);
  if (!header) return DEFAULT_HEADER_OFFSET_PX;

  return Math.ceil(header.getBoundingClientRect().height);
}

export function syncSiteHeaderOffsetCssVar(): number {
  const offsetPx = getSiteHeaderOffsetPx();
  document.documentElement.style.setProperty(
    HEADER_OFFSET_CSS_VAR,
    `${offsetPx}px`,
  );
  return offsetPx;
}

export function scrollToElementBelowSiteHeader(element: HTMLElement): void {
  syncSiteHeaderOffsetCssVar();
  element.scrollIntoView({ behavior: "smooth", block: "start" });
}
